import { render } from "./FeedCandleChart.vue?vue&type=template&id=8585ce52&scoped=true&ts=true"
import script from "./FeedCandleChart.vue?vue&type=script&lang=ts"
export * from "./FeedCandleChart.vue?vue&type=script&lang=ts"

import "./FeedCandleChart.vue?vue&type=style&index=0&id=8585ce52&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8585ce52"]])

export default __exports__